<template>
    <div class="container">
         <div class="row no-gutters height-self-center">
            <div class="col-sm-12 text-center align-self-center">
               <div class="iq-error position-relative">
                     <img src="/assets/images/error/erreur-403-forbidden-http-wordpress.jpg" class="imgz img-fluid iq-error-img" alt="">
                     <h2 class="mb-0 mt-4">Not allowed!</h2>
                     <p>You do not have the necessary authorization to reach this page.</p>
                     <router-link class="btn btn-primary d-inline-flex align-items-center mt-3" to="/"><i class="ri-home-4-line"></i>Back to Home</router-link>
               </div>
            </div>
         </div>
   </div>
</template>

<style>

</style>